/**
 *
 */
(function() {
  'use strict';
  angular.module('cbl.telepass.wa').service('TlpsLoggerSrvc', [
    '$http',
    'TLPS_CONSTANTS',
    function($http, CONSTANTS) {
      /**
       * Constants
       */
      this.SEVERE = 'SEVERE';
      this.WARNING = 'WARNING';
      this.INFO = 'INFO';
      this.CONFIG = 'CONFIG';
      this.FINE = 'FINE';
      this.FINER = 'FINER';
      this.FINEST = 'FINEST';
      var LEVELS = [
        this.FINEST,
        this.FINER,
        this.FINE,
        this.CONFIG,
        this.INFO,
        this.WARNING,
        this.SEVERE
      ];

      /**
       * Default value
       */
      this.loggerLevelString = this.FINEST;

      this.loggerLevel = LEVELS.indexOf(this.loggerLevelString);

      this.setupLogger = function(baseLevel) {
        if (LEVELS.indexOf(baseLevel) !== -1) {
          this.loggerLevelString = baseLevel;
        }
        this.loggerLevel = LEVELS.indexOf(this.loggerLevelString);
      };

      this.levelEnabled = function(level) {
        return this.loggerLevel <= LEVELS.indexOf(level);
      };

      this.formattaMessaggio = function(logPayload) {
        var message = '';
        if (typeof logPayload !== 'string') {
          if (Object.prototype.toString.call(logPayload) === '[object Array]') {
            for (var idx in logPayload) {
              if (typeof logPayload[idx] === 'string') {
                message += ' ' + logPayload[idx];
              } else {
                message += ' ' + JSON.stringify(logPayload[idx]);
              }
            }
          } else {
            message += JSON.stringify(logPayload);
          }
          return message;
        } else {
          return logPayload;
        }
      };

      this.log = function(controller, type, message) {
        message = this.formattaMessaggio(message);

        var level = LEVELS.indexOf(type);

        if (level < this.loggerLevel) {
          return;
        }

        $http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LOG,
          data: {
            level: type,
            msg: message,
            ctrl: controller
          }
        });
      };
    }
  ]);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/servicesUtilities/loggerSrvc.js
// module id = 6
// module chunks = 0